import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M6 5C6 4.2282 6.83721 3.74733 7.50387 4.13622L19.5039 11.1362C20.1654 11.5221 20.1654 12.4779 19.5039 12.8638L7.50387 19.8638C6.83721 20.2527 6 19.7718 6 19V5ZM8 6.74103V17.259L17.0154 12L8 6.74103Z" />,
  'Play'
);
